import { render } from "./ContactInfoForm.vue?vue&type=template&id=60522b0a"
import script from "./ContactInfoForm.vue?vue&type=script&lang=js"
export * from "./ContactInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__